<div class="row g-3 sheet-split">
  <section class="col-12 col-lg-6 sheet-block">
    <h3 class="sheet-block-title">Oggetto</h3>
    <dl class="sheet-facts">
      @if (objectInfo?.obj_definitionlevel1?.definition) {
        <div>
          <dt>Definizione</dt>
          <dd>{{ objectInfo.obj_definitionlevel1.definition }}</dd>
        </div>
      }
      @if (objectInfo?.obj_definitionlevel2?.definition) {
        <div>
          <dt>Tipologia</dt>
          <dd>{{ objectInfo.obj_definitionlevel2.definition }}</dd>
        </div>
      }
      @if (objectInfo?.obj_definition_level3?.definition) {
        <div>
          <dt>Identificazione</dt>
          <dd>{{ objectInfo.obj_definition_level3.definition }}</dd>
        </div>
      }
      @if (objectInfo?.quantity) {
        <div>
          <dt>Quantità</dt>
          <dd>{{ objectInfo.quantity }}</dd>
        </div>
      }
    </dl>
  </section>

  <section class="col-12 col-lg-6 sheet-block">
    <h3 class="sheet-block-title">Soggetto</h3>
    <dl class="sheet-facts">
      <div>
        <dt>Identificazione</dt>
        <dd>
          @for (item of objectInfo?.obj_identification; track item; let i = $index) {
            {{ item.definition }}@if (i + 1 < objectInfo.obj_identification.length) {; }
          }
        </dd>
      </div>
      @if (objectInfo?.obj_title?.length > 0) {
        <div>
          <dt>Titolo</dt>
          <dd>
            @for (item of objectInfo.obj_title; track item; let i = $index) {
              @if (item.definition?.length > 0) {
                {{ item.definition }}@if (i + 1 < objectInfo.obj_title.length) {; }
              }
            }
          </dd>
        </div>
      }
    </dl>
  </section>
</div>

@if (objectInfo?.specifications) {
  <section class="sheet-block sheet-block--full">
    <h3 class="sheet-block-title">Collocazione specifica</h3>
    <dl class="sheet-facts">
      <div>
        <dt>Specifiche</dt>
        <dd>{{ objectInfo.specifications }}</dd>
      </div>
    </dl>
  </section>
}
